import i18n from "lib/i18n"
import template from "lodash/template"
import { View } from "backbone"
import ContactAuthorFormView from "views/contact_author_form_view"
import { isSessionActive } from "lib/currentUser/session"

const _contactButtonTemplate = template(
  `\

<a data-testid="contact-author" class="profile-contact-button signed-in button primary large" href="#">
<%- i18n.t('author_communication.button.contact') %>
</a>\
`,
  { imports: { i18n } },
)

const _signUpToContactButtonTemplate = template(
  `\
<a
class="profile-contact-button sign-up-required button primary large"
href="/sign_in?return_to=${window.location.pathname}"
>
<%- i18n.t('author_communication.button.sign_in_to_contact') %>
</a>\
`,
  { imports: { i18n } },
)

const contactAuthorViewEvents = { "click .profile-contact-button.signed-in": "_contactAuthor" }

class ContactAuthorView extends View {
  get events() {
    return contactAuthorViewEvents
  }

  get _contactButtonTemplate() {
    return _contactButtonTemplate
  }

  get _signUpToContactButtonTemplate() {
    return _signUpToContactButtonTemplate
  }

  initialize(options) {
    super.initialize(options)

    this.render = this.render.bind(this)
    this._userBannedFromContactingAuthors = this._userBannedFromContactingAuthors.bind(this)
    this._userNotSignedIn = this._userNotSignedIn.bind(this)
    this._contactAuthor = this._contactAuthor.bind(this)

    this.user_id = options.user_id
    this.currentUserCanContactAuthors = options.currentUserCanContactAuthors
    this.contactable = options.contactable
    this.availableFor = options.availableFor

    return this.render()
  }

  render() {
    if (!this.contactable) {
      return
    }

    // Remove the invisible placeholder because we're about to render the
    // real button.
    this.$el.find(".contact-button-placeholder").remove()

    if (this._userNotSignedIn()) {
      this.$el.prepend(this._signUpToContactButtonTemplate())
    } else if (!this._userBannedFromContactingAuthors()) {
      this.$el.prepend(this._contactButtonTemplate())
    }

    super.render()
  }

  _userBannedFromContactingAuthors() {
    return !this.currentUserCanContactAuthors
  }

  _userNotSignedIn() {
    return !isSessionActive()
  }

  _contactAuthor(event) {
    event.preventDefault()
    new ContactAuthorFormView({
      author_id: this.user_id,
      availableFor: this.availableFor,
    }).$el.appendTo(document.body)
  }
}

export default ContactAuthorView
